import PiranhaProfitsLogo from "../../assets/images/logos/piranhaprofits-logo.png";
import PiranhaProfitsWhiteLogo from "../../assets/images/logos/piranhaprofits-white-logo.png";
import StockOracleLogo from "../../assets/images/logos/stockoracle-logo.jpg";
import StockOracleWhiteLogo from "../../assets/images/logos/stockoracle-white-logo.png";

// ============================================================
// LOGO OPTIONS
// ============================================================

export const LOGO_OPTIONS = [
  {
    label: "Piranha Profits",
    value: "piranhaprofits_logo",
    src: PiranhaProfitsLogo,
  },
  {
    label: "Piranha Profits (White)",
    value: "piranhaprofits_white_logo",
    src: PiranhaProfitsWhiteLogo,
  },
  {
    label: "StockOracle™",
    value: "stockoracle_logo",
    src: StockOracleLogo,
  },
  {
    label: "StockOracle™ (White)",
    value: "stockoracle_white_logo",
    src: StockOracleWhiteLogo,
  },
];

// ============================================================
// GENERAL
// ============================================================

export const MAX_FEATURE_LENGTH = 500;
export const MAX_FEATURES = 15;

export const MESSAGE_DISPLAY_DURATION = 3000;

// ============================================================
// PAGE
// ============================================================

export const DEFAULT_BACKGROUND_TYPE = "solid";
export const DEFAULT_BACKGROUND_COLOR = "#f6f7fa";

export const DEFAULT_BACKGROUND_GRADIENT_START_COLOR = "#f6f7fa";
export const DEFAULT_BACKGROUND_GRADIENT_END_COLOR = "#002766";
export const DEFAULT_BACKGROUND_GRADIENT_ANGLE = 135;

// ============================================================
// FONT
// ============================================================

export const DEFAULT_PAGE_FONT_SIZE = 14;
export const MIN_PAGE_FONT_SIZE = 1;

export const DEFAULT_PAGE_FONT_FAMILY = "arial";

export const FONT_FAMILY_OPTIONS = [
  {
    label: "System Default",
    value: "system",
    css: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  {
    label: "Arial",
    value: "arial",
    css: "Arial, Helvetica, sans-serif",
  },
  {
    label: "Courier New",
    value: "courier_new",
    css: '"Courier New", Courier, monospace',
  },
  {
    label: "Georgia",
    value: "georgia",
    css: 'Georgia, "Times New Roman", serif',
  },
  {
    label: "Helvetica",
    value: "helvetica",
    css: "Helvetica, Arial, sans-serif",
  },
  {
    label: "Montserrat",
    value: "montserrat",
    css: '"Montserrat", Arial, sans-serif',
    googleFont: "Montserrat",
  },
  {
    label: "Poppins",
    value: "poppins",
    css: '"Poppins", Arial, sans-serif',
    googleFont: "Poppins",
  },
  {
    label: "Roboto",
    value: "roboto",
    css: '"Roboto", Arial, sans-serif',
    googleFont: "Roboto",
  },
  {
    label: "Tahoma",
    value: "tahoma",
    css: "Tahoma, Geneva, sans-serif",
  },
  {
    label: "Times New Roman",
    value: "times_new_roman",
    css: '"Times New Roman", Times, serif',
  },
  {
    label: "Trebuchet MS",
    value: "trebuchet_ms",
    css: '"Trebuchet MS", Arial, sans-serif',
  },
  {
    label: "Verdana",
    value: "verdana",
    css: "Verdana, Geneva, sans-serif",
  },
];

// ============================================================
// TESTIMONIAL
// ============================================================

export const DEFAULT_TESTIMONIAL_BACKGROUND_COLOR = "#edf1f9";
export const DEFAULT_TESTIMONIAL_BORDER_COLOR = "#dbe1eb";

// ============================================================
// ADDITIONAL CONTENT
// ============================================================

export const DEFAULT_ADDITIONAL_CONTENT_BACKGROUND_COLOR = "#fbf6ea";
export const DEFAULT_ADDITIONAL_CONTENT_BORDER_COLOR = "#f8f7f6";

// ============================================================
// LEGAL CONTENT
// ============================================================

export const DEFAULT_SUB_FOOTER_CONTENT_BACKGROUND_COLOR = "#ffffff";
export const DEFAULT_SUB_FOOTER_CONTENT_BORDER_COLOR = "#ffffff";

// ============================================================
// CTA
// ============================================================

export const DEFAULT_CTA_FONT_SIZE = 16;
export const MIN_CTA_FONT_SIZE = 1;

export const DEFAULT_CTA_BACKGROUND_COLOR = "#1b2a4a";
export const DEFAULT_CTA_COLOR = "#ffffff";

export const DEFAULT_CTA_BORDER_RADIUS = 8;
export const MIN_CTA_BORDER_RADIUS = 0;
export const MAX_CTA_BORDER_RADIUS = 100;

export const DEFAULT_STANDARD_CTA_LABEL = "Complete Enrollment →";
export const DEFAULT_FREE_TRIAL_CTA_LABEL = "Start My Free Trial →";

// ============================================================
// FEATURES
// ============================================================

export const DEFAULT_FEATURE_SYMBOL = "✓";
export const DEFAULT_FEATURE_SYMBOL_COLOR = "#ffffff";
export const DEFAULT_FEATURE_SYMBOL_BACKGROUND_COLOR = "#2c7a4b";
export const DEFAULT_FEATURE_SYMBOL_SHAPE = "circle";
